import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Row, Col, Button, Container, Modal, Carousel, Form, CloseButton } from "react-bootstrap";
import Footer from "../Footer/Footer";
import "../../assest/css/Portfolio.css";
import axios from "axios";
import Apiurl from "../environments/Apiurl";
import { FiArrowUpRight } from "react-icons/fi";

// Dummy Image (replace with your assets, kept for default fallback)
import instagramPosts1 from "../../assest/image/Portfolio/Social/Social (1).jpg";

function Portfolio() {
  const [activeTab, setActiveTab] = useState("works");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [getStudentData, setGetStudentData] = useState([]);
  const [getAchievementsData, setGetAchievementsData] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Fetch data
  useEffect(() => {
    axios.get(`${Apiurl}/portfolio/successful-student`)
      .then((res) => setGetStudentData(res.data.students || res.data || []))
      .catch((err) => console.error("Error fetching students:", err));
  }, []);

  useEffect(() => {
    axios.get(`${Apiurl}/portfolio/student-achievement`)
      .then((res) => setGetAchievementsData(res.data.achievements || res.data || []))
      .catch((err) => console.error("Error fetching achievements:", err));
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(`${Apiurl}/portfolio/project`);
        // Filter out draft projects - only show published ones
        const publishedProjects = (res.data.projects || []).filter(project => project.status === "published");
        setProjects(publishedProjects);
      } catch (error) {
        console.error("Error fetching projects:", error.message);
      }
    };

    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${Apiurl}/portfolio/categories`);
        setCategories(["All", ...res.data.categories]);
      } catch (error) {
        console.error("Error fetching categories:", error.message);
      }
    };

    fetchProjects();
    fetchCategories();
  }, []);

  const cleanImageUrl = (url) => {
    if (!url) return instagramPosts1;
    if (url.startsWith("http")) return url.replace(/\/uploads\/+uploads\//, "/uploads/");
    const baseUrl = Apiurl.replace(/\/api\/?$/, "");
    return `${baseUrl}${url}`;
  };

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    setShowModal(true);
  };

  return (
    <HelmetProvider>
      <div className="container-fluid p-0 about-container">
        <Helmet>
          <title>Portfolio - Aalan TechSoft | Our Projects</title>
          <meta
            name="description"
            content="Explore Aalan TechSoft’s portfolio showcasing our projects, student success stories, and achievements."
          />
        </Helmet>

        {/* Hero Section */}
        <div className="Portfolio-hero text-center text-white d-flex align-items-center justify-content-center">
          <div>
            <span className="badge-title">Portfolio</span>
            <h1 className="fw-bold mt-2">
              Showcasing Innovation, Excellence, and Impact
            </h1>
          </div>
        </div>

        {/* Portfolio Tabs */}
        <section className="portfolio-section py-5 mt-3">
          <Container>
            {/* Tabs */}
            <div className="d-flex justify-content-center flex-wrap gap-2 mb-4">
              {["works", "students", "achievements"].map((tab) => (
                <Button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`tab-button ${activeTab === tab ? "active" : ""}`}
                >
                  {tab === "works"
                    ? "Case Study"
                    : tab === "students"
                      ? "Successful Students"
                      : "Students Achievements"}
                </Button>
              ))}
            </div>

            {/* Tab Content */}

            <div className="tab-content-box p-3 rounded">
              {/* Case Studies */}
              {activeTab === "works" && (
                <>
                  <Col xs={12} className="text-center mb-3 pb-4">
                    <h2>Projects we successfully developed</h2>
                    <p className="Section-text">
                      One look is worth a thousand words.
                    </p>
                  </Col>
                  <div className="d-flex justify-content-start mb-5">
                    <Form.Select
                      aria-label="Select category"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)}
                      className="w-auto category-select"
                      style={{ minWidth: '180px' }} // Adjust width as needed for your layout
                    >
                      {categories.map((cat) => (
                        <option key={cat} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </Form.Select>
                  </div>

                  <Row className="g-4">
                    {filteredProjects.length > 0 ? (
                      filteredProjects.map((project) => (
                        <Col xs={12} lg={6} key={project._id}>
                          <div
                            className="case-card shadow-sm rounded-2 overflow-hidden bg-white"
                            onClick={() => handleProjectClick(project)}
                            style={{ cursor: 'pointer' }}
                          >
                            <Row className="g-0">
                              <Col xs={12}>
                                <img
                                  src={cleanImageUrl(project.cover_image)}
                                  alt={project.project_title}
                                  className="img-fluid w-100 case-img"
                                  style={{ height: "400px", objectFit: "cover" }}
                                />
                              </Col>
                              <Col xs={12} className="p-4 d-flex flex-column">
                                <div>
                                  <h5 className="fw-semibold mb-2">{project.project_title}</h5>
                                  {selectedProject?.services && <p><strong>Services:</strong> {selectedProject.services}</p>}

                                </div>
                                <div className="mt-auto">
                                  <Button
                                    variant="link"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleProjectClick(project);
                                    }}
                                    className="p-0 text-decoration-none view-btn"
                                  >
                                    View Full Case Study <i className="bi bi-arrow-right ms-1"></i>
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      ))
                    ) : (
                      <Col xs={12}>
                        <p className="text-center text-muted">No projects found.</p>
                      </Col>
                    )}
                  </Row>
                </>
              )}

              {/* Students */}
              {activeTab === "students" && (
                <Row className="g-4">
                  <Col xs={12} className="text-center mb-3">
                    <h2>Our Recent Placements</h2>
                    <p className="Section-text">
                      Celebrating our successfully placed students thriving in top companies.
                    </p>
                  </Col>
                  {getStudentData.length > 0 ? (
                    getStudentData.map((item, index) => (
                      <Col xs={12} sm={6} lg={4} key={item._id || index}>
                        <div className="student-card text-center shadow p-3 rounded-3 h-100">
                          <img
                            src={cleanImageUrl(item.student_image)}
                            alt={item.student_name}
                            className="img-fluid rounded-3 mb-3"
                            style={{ height: "360px", objectFit: "cover" }}
                          />
                          {/* <h5>{item.student_name}</h5>
                          <p className="text-muted mb-1">{item.student_domain}</p>
                          <p className="fw-semibold text-dark">Placed at {item.student_placed}</p> */}
                        </div>
                      </Col>
                    ))
                  ) : (
                    <Col xs={12}>
                      <p className="text-center text-muted">No students found.</p>
                    </Col>
                  )}
                </Row>
              )}

              {/* Achievements */}
              {activeTab === "achievements" && (
                <Row className="g-4">
                  <Col xs={12} className="text-center mb-3">
                    <h2>Our Students Achievements</h2>
                    <p className="Section-text">
                      We’re proud of the milestones reflecting our students’ dedication.
                    </p>
                  </Col>
                  {getAchievementsData.length > 0 ? (
                    getAchievementsData.map((item, index) => (
                      <Col xs={12} sm={6} lg={4} key={item._id || index}>
                        <div className="student-card text-center shadow p-3 rounded-3 h-100">
                          <img
                            src={cleanImageUrl(item.course_image)}
                            alt={`${item.student_name}'s achievement`}
                            className="img-fluid rounded-3 mb-3"
                            style={{ height: "360px", objectFit: "cover" }}
                          />

                        </div>
                      </Col>
                    ))
                  ) : (
                    <Col xs={12}>
                      <p className="text-center text-muted">No achievements found.</p>
                    </Col>
                  )}
                </Row>
              )}
            </div>
          </Container>
        </section>


        {/* popupmodal */}

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          size="xl"
          centered
          className="custom-project-modal align-items-center justify-content-center"
        >

          <div className="position-relative">
            <CloseButton
              onClick={() => setShowModal(false)}
              style={{ position: "absolute", top: 10, right: 10, zIndex: 9999 }}
              className="text-white"
            />

            <Modal.Body className="p-0 d-flex h-100 align-items-center justify-content-center">
              {/* Left Side */}
              <div
                className="p-4 d-flex align-items-center justify-content-center"
                style={{ width: '50%', }}
              >
                {selectedProject?.project_image?.length > 0 ? (
                  <Carousel indicators={false} controls={true} className="h-100 w-100 d-flex align-items-center justify-content-center">
                    {selectedProject.project_image.map((img, index) => (
                      <Carousel.Item key={index} className="h-100 d-flex align-items-center justify-content-center">
                        <img
                          src={cleanImageUrl(img)}
                          className="d-block"
                          style={{
                            maxHeight: '70vh',
                            maxWidth: '100%',
                            objectFit: 'contain'
                          }}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  selectedProject?.cover_image && (
                    <img
                      src={cleanImageUrl(selectedProject.cover_image)}
                      className="img-fluid rounded"
                      style={{
                        maxHeight: '70vh',
                        maxWidth: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  )
                )}
              </div>

              {/* Right Side */}
              <div
                className="d-flex flex-column text-start p-4"
                style={{ width: '50%' }}
              >
                <div className="text-start">
                  <Modal.Title className="mb-3">{selectedProject?.project_title}</Modal.Title>
                  <p><strong>Description:</strong> {selectedProject?.description}</p>
                  {selectedProject?.industries && <p><strong>Industries:</strong> {selectedProject.industries}</p>}
                  {selectedProject?.services && <p><strong>Services:</strong> {selectedProject.services}</p>}
                  {selectedProject?.technologies && <p><strong>Technologies:</strong> {selectedProject.technologies}</p>}
                  {selectedProject?.project_link && (

                    <Button
                      href={selectedProject.project_link}
                      target="_blank"
                      className="custom-btn mt-4 shadow-sm"
                      style={{ width: "180px", textAlign: "left" }}
                    >
                      <span className="btn-text fw-semibold">Visit Project</span>
                      <span className="btn-icon ms-2">
                        <FiArrowUpRight />
                      </span>
                    </Button>
                  )}
                </div>
              </div>

            </Modal.Body>
          </div>

        </Modal>

        <Footer />
      </div>

      <style>{`
        /* Mobile + Tablet Fixes */
       
        
        .case-card {
          transition: all 0.3s ease;
        }
        .case-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        
       
        @media (max-width: 768px) {
          .Portfolio-hero h1 {
            font-size: 1.5rem;
            padding: 0 15px;
          }
          .case-img {
            height: 220px !important;
          }
          .case-card {
            flex-direction: column !important;
          }
        }
      `}</style>
    </HelmetProvider>
  );
}

export default Portfolio;